import React from 'react'
import { useTranslation } from 'react-i18next'
import { EnrichedIssueEntity } from 'types/IssueEntity'
import { FactsTableRow } from '../../components/FactsTable'
import { formatMoney } from '../../../packages/utils/numberFormatters'

const safeMultiply = (x: number | null, y: number | null): number | null => {
    if (x === null || y === null) return null

    return x * y
}

export function AmountRow({ issue }: { issue: EnrichedIssueEntity }) {
    const { t, i18n } = useTranslation()
    const locale = i18n.language
    const baseTotal = issue.unitSubTotal ?? issue.totalOfferedUnits ?? null
    const baseAmount = safeMultiply(baseTotal, issue.unitSubPrice)
    const secondaryAmount = safeMultiply(issue.secondarySub, issue.unitSubPrice)

    if (issue.type === 'ABB Directed issue' && issue.unitSubTotal === null) {
        return null
    } else if (secondaryAmount !== null && baseAmount !== null) {
        return (
            <FactsTableRow label={t('pages.issues.terms.amount')}>
                {formatMoney(baseAmount, { locale, decimals: 0 })} (+
                {formatMoney(secondaryAmount, { locale, decimals: 0 })}) {issue.currency}
            </FactsTableRow>
        )
    } else if (baseAmount !== null) {
        return (
            <FactsTableRow label={t('pages.issues.terms.amount')}>
                {formatMoney(baseAmount, { locale, currencySymbol: issue.currency, decimals: 0 })}
            </FactsTableRow>
        )
    } else if (issue.abbTarget !== null) {
        return (
            <FactsTableRow label={t('pages.issues.terms.amount')}>
                {formatMoney(issue.abbTarget, { locale, currencySymbol: issue.currency, decimals: 0 })}
            </FactsTableRow>
        )
    } else {
        return (
            <FactsTableRow label={t('pages.issues.terms.amount')}>
                <span>{t('pages.issues.terms.notDeterminedYet')}</span>
            </FactsTableRow>
        )
    }
}
